import { render, staticRenderFns } from "./InfosetsLegacy.vue?vue&type=template&id=210670e0&scoped=true&"
import script from "./InfosetsLegacy.vue?vue&type=script&lang=ts&"
export * from "./InfosetsLegacy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210670e0",
  null
  
)

export default component.exports